import { filter } from 'rxjs/operator/filter';
import { error } from 'util';
import * as events from 'events';
import _ from 'lodash';
import { Component, ElementRef, EventEmitter, Input, NgZone, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CountryService, CityService, PortService, AirPortService, Country, Port, Airport, City, Address, Location, GmapLogService } from '../../../../services/index';
import { MapsAPILoader } from '@agm/core';
declare var google:any;
declare var $:any;
import scrollIntoViewIfNeeded from 'scroll-into-view-if-needed';

@Component({
  selector: 'location-selector',
  templateUrl: 'location-selector.html'
})
export class LocationSelectorComponent implements OnInit {
  @Input() itemTypes:Array<string> = ['city', 'port', 'air'];
  @Input() savedCountry;
  @Input() savedAddress;
  @Input() savedDetailAddress;
  @Input() addressDetail:boolean = true;
  @Input() savedLocation:Location;
  
  @Output() onCountrySelect:EventEmitter<Country> = new EventEmitter();
  @Output() onLocationSelect:EventEmitter<Location> = new EventEmitter();
  @Output() onAddressSelect:EventEmitter<Address> = new EventEmitter();
  @Output() onDetailAddressSelect:EventEmitter<any> = new EventEmitter();
  
  isCntryListOpen: boolean = false;
  focusedCntryIndex: number = 0;
  isPortCityListOpen: boolean = false;
  focusedLocationIndex: number = 0;

  selectedCntry:Country;
  selectedLocation:Location;
  selectedAddress:Address;
  addressError: boolean = false;

  countries: Array<Country> = [];
  ports: Array<Port> = [];
  airports: Array<Airport> = [];

  filteredCountryList: Array<Country> = [];
  cntryLocations = {
    city: [],
    port: [],
    airport: []
  };
  
  filteredPortAirCity: Array<any> = [];

  countryControl: FormControl = new FormControl();
  portAirCityControl: FormControl = new FormControl();
  addressControl: FormControl = new FormControl();
  dtlAddressControl: FormControl = new FormControl();
  
  mapOptions = {
    fields: ["name", "address_components", "geometry.location"],
    componentRestrictions: null
  };

  country: string = '';
  address:string = '';
  dtlAddress:string = '';

  constructor(
    private countryService: CountryService,
    private cityService: CityService,
    private portService: PortService,
    private airportService: AirPortService,
    private mapsAPILoader: MapsAPILoader, 
    private ngZone: NgZone,
    private gmapLogService:GmapLogService
	) {}


  @ViewChild("detailAddress")
  searchElementRef: ElementRef;

  @ViewChild("countryList")
  countryListElRef: ElementRef;

  @ViewChild("portAirCityList")
  portAirCityListElRef: ElementRef;

  @ViewChild("countryRef")
  countryElRef: ElementRef;

  @ViewChild("portAirCityRef")
  portAirCityElRef: ElementRef;


  ngOnInit() {
    this.countries = this.countryService.countries;
    this.countryService.countryListEe.subscribe(countries => {
      this.countries = countries;
    });

    this.ports = this.portService.ports;
    this.portService.portListEe.subscribe(
      ports => {
        this.ports = ports;
    });

    this.airports = this.airportService.airports;
    this.airportService.airPortListEe.subscribe(
      airports => {
        this.airports = airports;
      }
    );

    
  }

  ngOnChanges(changes:SimpleChanges) {
    if(!_.isEmpty(changes.savedCountry)) {
      this.country = this.savedCountry;
      this.countryControl.setValue(this.country);
    }
    if(!_.isEmpty(changes.savedAddress)) {
      this.address = this.savedAddress;
      if(this.address){
        this.address = this.address.replace('[Airport] ','').replace('[Port] ', '');
      }
      this.portAirCityControl.setValue(this.address);
    }
    if(!_.isEmpty(changes.savedDetailAddress)) {
      this.dtlAddress = this.savedDetailAddress;
      this.dtlAddressControl.setValue(this.dtlAddress);
    }
    if(!_.isEmpty(changes.savedLocation)) {
      if(this.savedLocation) {
        this.countries = this.countryService.countries;
        if(_.isEmpty(this.countries)) {
          this.countryService.countryListEe.subscribe(countries => {
            this.countries = countries;
            this.setSavedLocation();
          });
        } else {
          this.setSavedLocation();
        }
        
      } else {
        this.selectedCntry = null;
        this.savedLocation = null;
        this.countryControl.setValue('');
        this.portAirCityControl.setValue('');
      }
    }
  }

  setSavedLocation() {
    let cntry = _.find(this.countries, {cntryCd : this.savedLocation.cntryCd});
    this.cntryListSelectHandler(cntry);
    this.selectedLocation = this.savedLocation;
    this.portAirCityControl.setValue(this.savedLocation.name);
  }

  setAutoComplete() {
    this.mapsAPILoader.load().then(() => {
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement, this.mapOptions);
      this.gmapLogService.log('freight-quotes', 'PLACE');

      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          this.selectedAddress = new Address();
          this.selectedAddress.address = this.searchElementRef.nativeElement.value;
          this.selectedAddress.latitude = place.geometry.location.lat();
          this.selectedAddress.longitude = place.geometry.location.lng();

          this.addressError = false;
          this.onAddressSelect.emit(this.selectedAddress);
        });
      });
    });
  }

  setFilteredCountryList(event) {
    if (!event) return;
    
    let keyword = event.target.value;
    if (!keyword) {
      if (this.selectedCntry) this.selectedCntry = null;
      this.onCountrySelect.emit(null);
      this.onLocationSelect.emit(null)
      this.onAddressSelect.emit(null);
      this.selectedLocation = null;
      this.selectedAddress = null;
      this.isCntryListOpen = false;
      return;
    }

    if(keyword.length > 0) {
      keyword = _.toUpper(keyword.trim()).replace(/\s/g, '');
		  let filteredCountryList = _.map(_.filter(this.countries,
																	(cntry) => {
																		if (keyword.length <= 0) return true;
																		else if (_.toUpper(cntry.cntryNm.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
																		else if (_.upperCase(cntry.cntryCd).indexOf(keyword) >= 0) return true;
																		else return false;
                                  }));
      
      this.filteredCountryList = _.sortBy(filteredCountryList,
																(cntry) => {
																	let nmIndex = _.toUpper(cntry.cntryNm.trim()).replace(/\s/g, '').indexOf(keyword);
																	let cdIndex = _.upperCase(cntry.cntryCd).indexOf(keyword);
																	if (nmIndex < 0) nmIndex = 999;
																	if (cdIndex < 0) cdIndex = 999;
																	return _.min([nmIndex, cdIndex])
																});

      this.isCntryListOpen = true;
      this.focusedCntryIndex =  0;    
    } else {
      this.isCntryListOpen = false;
    }

    if(_.isEmpty(this.countryControl.value)) {
      this.portAirCityControl.setValue('');
    } 
  }

  checkCountryEmpty() {
    if(_.isEmpty(this.countryControl.value)) {
      $.sweetModal('국가를 먼저 선택하세요.');  
    }
  }

  cntryListSelectHandler(cntry) {
    this.isCntryListOpen = false;
    this.selectedCntry = cntry;
    this.mapOptions.componentRestrictions = {country: this.selectedCntry.cntryCd};
    
    this.countryControl.setValue(this.selectedCntry.cntryNm);
    this.onCountrySelect.emit(this.selectedCntry);

    this.cntryLocations.city = new Array<City>();
    this.cntryLocations.port = new Array<Port>();
    this.cntryLocations.airport = new Array<Airport>();
    
    this.cityService.getCities(this.selectedCntry.cntryCd).subscribe(
      data => this.cntryLocations.city = data,
      err => console.log("Error code: %s, URL: %s", err.status, err.url)
    );

    let filteredPorts = _.filter(this.ports, {'cntryCd' : this.selectedCntry.cntryCd});
    this.cntryLocations.port = filteredPorts;

    let filteredAirports = _.filter(this.airports, {'cntryCd' : this.selectedCntry.cntryCd});
    this.cntryLocations.airport = filteredAirports;
  }

  onPortAirCityInput(event) {
    if(_.isEmpty(this.countryControl.value)) {
      $.sweetModal('국가를 먼저 선택하세요.');
      return;
    };
    let val;
    if(event && event.target){
      val = event.target.value;
    }else{
      val = event;
    }
    if (!val) {
      if (this.selectedLocation) this.selectedLocation = null;
      this.onLocationSelect.emit(null);
      this.isPortCityListOpen = false;
      return;
    }

    if(val.length <= 2) {
      this.isPortCityListOpen = false;
    } else {
      this.isPortCityListOpen = true;
      //let keyword = _.trim(_.upperCase(val));

      let keyword = _.toUpper(val.trim()).replace(/\s/g, '');
      
      let filteredPortList = [];
      if (_.includes(this.itemTypes, 'port')) {
        filteredPortList = _.map(_.filter(this.cntryLocations.port,
                  (port) => {
                    if (keyword.length <= 0) return true;
                    else if (_.toUpper(port.portNm.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
                    else if (_.upperCase(port.portCd).indexOf(keyword) >= 0) return true;
                    else return false;
                  }));

        filteredPortList = _.sortBy(filteredPortList,
              (port) => {
                let nmIndex = _.toUpper(port.portNm.trim()).replace(/\s/g, '').indexOf(keyword);
                let cdIndex = _.upperCase(port.portCd).indexOf(keyword);
                if (nmIndex < 0) nmIndex = 999;
                if (cdIndex < 0) cdIndex = 999;
                return _.min([nmIndex, cdIndex])
              });
      } else {
        filteredPortList = [];
      }

      let filteredAitportList = [];
      if (_.includes(this.itemTypes, 'air')) {
        filteredAitportList = _.map(_.filter(this.cntryLocations.airport,
                  (airport) => {
                    if (keyword.length <= 0) return true;
                    else if (_.toUpper(airport.portNm.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
                    else if (_.upperCase(airport.portCd).indexOf(keyword) >= 0) return true;
                    else return false;
                  }));

        filteredAitportList = _.sortBy(filteredAitportList,
                (airport) => {
                  let nmIndex = _.toUpper(airport.portNm.trim()).replace(/\s/g, '').indexOf(keyword);
                  let cdIndex = _.upperCase(airport.portCd).indexOf(keyword);
                  if (nmIndex < 0) nmIndex = 999;
                  if (cdIndex < 0) cdIndex = 999;
                  return _.min([nmIndex, cdIndex])
                });
      } else {
        filteredAitportList = [];
      }
      
      let filteredCityList = [];
      if (_.includes(this.itemTypes, 'city')) {
        filteredCityList = _.map(_.filter(this.cntryLocations.city,
                  (city) => {
                    if (keyword.length <= 0) return true;
                    else if (_.toUpper(city.name.trim()).replace(/\s/g, '').indexOf(keyword) >= 0) return true;
                    else if (_.upperCase(city.cityCd).indexOf(keyword) >= 0) return true;
                    else return false;
                  }));

        filteredCityList = _.sortBy(filteredCityList,
                (city) => {
                  let nmIndex = _.toUpper(city.name.trim()).replace(/\s/g, '').indexOf(keyword);
                  let cdIndex = _.upperCase(city.cityCd).indexOf(keyword);
                  if (nmIndex < 0) nmIndex = 999;
                  if (cdIndex < 0) cdIndex = 999;
                  return _.min([nmIndex, cdIndex])
                });
      } else {
        filteredCityList = [];
      }
      
      this.filteredPortAirCity = _.concat(filteredPortList, filteredAitportList, filteredCityList);
    }
  }

  locationListSelectHandler(location) {
    this.isPortCityListOpen = false;
    this.selectedLocation = location;
    this.portAirCityControl.setValue(location.name);

    this.onLocationSelect.emit(location);
    if(location.type === 'city' && this.addressDetail) {
      this.setAutoComplete();
    }
  }
  
  hideCountryList() {
    this.isCntryListOpen = false;
  }

  handleKeyDown(event) {
    if (event.keyCode !== 13 && event.keyCode !== 27 && event.keyCode !== 38 && event.keyCode !== 40 ) return;

		let suggestListDom = null;
		let focusedIndex = null;
		let type = null;

		if (event.target === this.countryElRef.nativeElement ) {
			type = 'cntry';
			suggestListDom = this.countryListElRef.nativeElement;
			focusedIndex = this.focusedCntryIndex;
		} else if (event.target === this.portAirCityElRef.nativeElement ) {
			type = 'city';
			suggestListDom = this.portAirCityListElRef.nativeElement;
			focusedIndex = this.focusedLocationIndex;
    }
    
    let suggestListItem = null;
    if (suggestListDom) suggestListItem = suggestListDom.querySelectorAll('li');


		switch (event.keyCode) {
			case 13: // enter
        if (type === 'cntry') {
					if (_.isEmpty(this.filteredCountryList) || !this.focusedCntryIndex == null || !this.isCntryListOpen) return;
					let item = this.filteredCountryList[this.focusedCntryIndex];
          this.cntryListSelectHandler(item);
          this.isCntryListOpen = false;
				} else if (type === 'city') {
					if (_.isEmpty(this.filteredPortAirCity) || !this.focusedLocationIndex == null || !this.isPortCityListOpen) return;
					let item = this.filteredPortAirCity[this.focusedLocationIndex];
          this.locationListSelectHandler(item);
          this.isPortCityListOpen = false;
				}
			  break;
			case 27: // escape
					this.isCntryListOpen = false;
          this.isPortCityListOpen = false;
          
          if (type === 'cntry') {
            if (this.selectedCntry) this.countryControl.setValue(this.selectedCntry.cntryNm);
          } else {
            if (this.selectedLocation) this.portAirCityControl.setValue(this.selectedLocation.name);
          }
			  break;
			case 38: // up
        focusedIndex--;
        if (focusedIndex < 0) focusedIndex = 0;
        // suggestListItem[focusedIndex].scrollIntoViewIfNeeded(true);
        scrollIntoViewIfNeeded(suggestListItem[focusedIndex], true);
			  break;
			case 40: // down
				focusedIndex++;
        if (focusedIndex > suggestListItem.length - 1) focusedIndex = suggestListItem.length - 1;
        //suggestListItem[focusedIndex].scrollIntoViewIfNeeded(false);
        scrollIntoViewIfNeeded(suggestListItem[focusedIndex], false);
        break;
			default: return;
		}

		
		if (type === 'cntry') {
			if (focusedIndex != this.focusedCntryIndex) this.focusedCntryIndex = focusedIndex;
		} else if (type === 'city') {
			if (focusedIndex != this.focusedLocationIndex) this.focusedLocationIndex = focusedIndex;
		}
    event.preventDefault();
  }

  handleKeyUp(event)
  {
      //좌우 방향키, 백스페이스, 딜리트, 탭키에 대한 예외
      if(event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 37 || event.keyCode == 39
      || event.keyCode == 46 ) return;
      
      event.target.value = event.target.value.replace(/[\ㄱ-ㅎㅏ-ㅣ가-힣]/g, '');
  }

  
  handleCntryBlur($event) {
    if (this.isCntryListOpen) this.isCntryListOpen = false;

    if (this.selectedCntry && $event.target.value) {
      this.countryControl.setValue(this.selectedCntry.cntryNm);
    } else {
      this.countryControl.setValue(null);
    }
  }

  handleLocationBlur($event) {
    if (this.isPortCityListOpen) this.isPortCityListOpen = false;

    let value;
    if($event && $event.target){
      value = $event.target.value;
    }else{
      value = $event;
    }
    if (this.selectedLocation && value) {
      this.portAirCityControl.setValue(this.selectedLocation.name);
    } else {
      this.portAirCityControl.setValue(null);
    }
  }

  handleDetailAddressBlur($event) {
    if(_.isEmpty(this.selectedAddress)) {
      this.addressControl.setValue(null);
      this.addressError = true;
    } else {
      this.addressError = false;
    }
  }

  addressHandler(event) {
    this.selectedAddress = new Address();
    if (!event.target.value) {
      this.onAddressSelect.emit(null);
    }
  }
  
  detailAddressHandler(event) {
    if (!event.target.value) {
      this.onDetailAddressSelect.emit(null);
    } else {
      this.onDetailAddressSelect.emit(event.target.value);
    }
  }
  setAddrssControl(address:Address){

    this.selectedAddress = address;

    this.addressControl.setValue(address.address);
    this.addressError = false;
    this.onAddressSelect.emit(address);
  }
  setDtlAddressControl(dtlAddrs){
    this.dtlAddressControl.setValue(dtlAddrs);
  }

}


// WEBPACK FOOTER //
// ./src/app/containers/quotation/consult/consult-sub/location-selector.ts